import React from "react";

import {bindActionCreators} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";
import moment from "moment";
import prettysize from "../../utils";

import {Modal, Button, message, Table, Tooltip, Input, Space} from "antd";

import UsersList from "./Users/users";

import "./usersListDashboard.scss";
import {DeleteFilled, SendOutlined} from "@ant-design/icons";

const {Search} = Input;

// const onSearch = value => console.log(value);

class UserDashbord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userList: [],
            pageSize: 50,
            page: 1,
            total: 0,
            searchUser: ""
        };
        this.onSearch = this.onSearch.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    onSearch(value) {
        console.log(value)
        // this.state.searchUser = value
        console.log(this.state.searchUser, "get done")
        this.setState({
            loading: true,
            searchUser: value
        });
        CloudFlyerAPI.user_account
            .fetchAllUsers(this.state.pageSize, this.state.page, value)
            .then(({data}) => {
                this.setState({
                    loading: false,
                    userList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    componentDidMount() {
        this.setState({
            loading: true,
        });
        this.fetchAllUsers();
    }

    fetchAllUsers() {
        CloudFlyerAPI.user_account
            .fetchAllUsers(this.state.pageSize, this.state.page, this.state.searchUser)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: false,
                    userList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onPageChange = page => {
        this.setState({page: page, loading: true})

        CloudFlyerAPI.user_account
            .fetchAllUsers(this.state.pageSize, page, this.state.searchUser)
            .then(({data}) => {
                this.setState({
                    loading: false,
                    userList: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    on_click_detail(e, id, name, accountId) {
        this.props.history.push("/usageDetail/?id=" + accountId + "&name=" + name + "&userId=" + id)
    }

    on_click_subscription(e, id,username) {
        this.props.history.push("/subscriptionAdmin/?id=" + id + "&username="+username)
    }

    handleDeleteClick(id) {
        CloudFlyerAPI.user_account
            .deleteUserAPI(id)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: true,
                });
                this.fetchAllUsers();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    handleResendEmail(postData) {
        CloudFlyerAPI.user_account
            .resendEmail(postData)
            .then(({data}) => {
                message.success(`Email sent successfully!`)
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }


    render() {
        let status = new Map();
        status.set(1, "Active");
        status.set(2, "Inactive");
        status.set(4, "Pending");

        let userType = new Map();
        userType.set(16, "Admin");
        userType.set(32, "Standard");
        userType.set(64, "Creative");


        const {providers} = this.state;
        const {match} = this.props;
        const {user, history} = this.props;
        const showDeleteConfirm = (
            e,
            handleDeleteClick,
            id) => {
            e.stopPropagation()
            Modal.confirm({
                title: `Are you sure you want to Delete this User?`,
                content:
                    "",
                onOk() {
                    handleDeleteClick(id)
                }
            })
        }
        const sendEmail = (
            e,
            handleResendEmail,
            id) => {
            e.stopPropagation()
            Modal.confirm({
                title: `Are you sure you want to resend signup invite email?`,
                content:
                    "",
                onOk() {
                    handleResendEmail(id)
                }
            })
        }
        const columns = [
            {
                title: "Username",
                dataIndex: "username",
                key: "username",
                ellipsis: {
                    showTitle: false,
                },
                render: (username) => (
                    <Tooltip placement="topLeft" title={username}>
                        {username}
                    </Tooltip>
                ),
                width: 100,
            },
            {
                title: "Total Usage (Previous Month)",
                dataIndex: "totalUsage",
                key: "totalUsage",
                width: 90,
            },
            {
                title: "Account Name",
                dataIndex: "accountName",
                key: "accountName",
                ellipsis: {
                    showTitle: false,
                },
                render: (accountName) => (
                    <Tooltip placement="topLeft" title={accountName}>
                        {accountName}
                    </Tooltip>
                ),
                width: 100,
            },
            {
                title: "Registration Date",
                dataIndex: "date",
                key: "date",
                width: 100,
            },
            {
                title: "Type",
                dataIndex: "userType",
                key: "userType",
                width: 60,
            },
            {
                title: "Owner",
                dataIndex: "owner",
                key: "owner",
                width: 50,
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                width: 40,
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                width: 100,
                ellipsis: {
                    showTitle: false,
                },
                render: action => (
                    <div className="userActions">

                        <Tooltip placement="topLeft" title="Resend Invite">
                            <SendOutlined className={action.status !== "Pending" ? 'hidden' : ''} onClick={e =>
                                sendEmail(e, this.handleResendEmail, action.postData,)
                            }/>
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Subscription">
                            <Button
                                className={`${action.owner ? '' : 'hidden'} replication-delete-btn`}
                                icon="dollar"
                                onClick={(e) =>
                                    this.on_click_subscription(e, action.detailData.id, action.detailData.username)
                                }
                            />
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Detail">
                            <Button
                                className="replication-delete-btn"
                                icon="arrow-right"
                                onClick={(e) =>
                                    this.on_click_detail(e, action.detailData.id, action.detailData.name, action.detailData.accountId)
                                }
                            />
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Delete User">
                            <DeleteFilled className={action.status} onClick={e =>
                                showDeleteConfirm(e, this.handleDeleteClick, action.id,)
                            }/>
                        </Tooltip>
                    </div>
                ),
            }
        ];

        let data = this.state?.userList?.map((t, index) => {
            return {
                key: t.id,
                id: t.id,
                username: t.username,
                accountName: t.accountName,
                totalUsage: prettysize(t.lastMonthUsage),
                date: moment(t.createDate).format("MM/DD/YYYY"),
                status: status.get(t.status),
                userType: userType.get(t.userType),
                owner: t.owner.toString(),
                userCount: t.usersCount,
                action: {
                    status: status.get(t.status),
                    id: t.id,
                    owner: t.owner,
                    postData: {
                        id: t.id,
                        username: t.username,
                        email: t.username,
                        firstname: t.firstname,
                        lastname: t.lastname,
                    },
                    detailData: {id: t.id, name: t.accountName, accountId: t.accountId,username: t.username}
                }
            };
        });

        return (
            <div className="usersListdashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2>Users</h2>
                    </div>
                    <div className="right-wrapper">
                        <Search className="search-user" placeholder="Search User Name" onSearch={this.onSearch} enterButton/>
                        <Button
                            className="add-user-btn"
                            type="primary"
                            onClick={() => history.push("/addNewUser")}
                        >
                            Add New User
                        </Button>
                    </div>
                </div>
                <div className="active-jobs-wrapper-list">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />

                </div>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth, cloudAccounts}, {match, history}) => {
            let user = auth.user;
            return {
                ...user,
                cloudAccounts,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(UserDashbord)
);
